import {createAction} from "redux-actions";

export const exitSigning = createAction("signtasks/EXIT_SIGNING");
